<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <template v-slot:activator="{ props }">
      <div v-bind="props" >
        <slot></slot>
      </div>
    </template>

    <v-card v-cloak class="vb-disable-mfa-dialog">
      <v-card-title class="d-flex justify-space-between">
        {{$t('menus.authentication.disableMFA')}}

        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        {{$t('menus.authentication.disableMFAConfirmation')}}
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
            v-on:click="disableMFA"
            v-bind:disabled="isSubmitted"
            v-bind:loading="isSubmitted"
            class="bg-red-darken-3"
            elevation=0
        >
          {{$t('menus.authentication.disableMFA')}}
        </v-btn>

        <v-btn variant="text" @click="dialog = false" data-cy="dialog-disableMFA-false">{{ isSubmitted ? $t('common.close') : $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import UserCalls from '@/api/modules/UserCalls.js';

export default {
  emits: ["update:is-processing"],
  mixins: [DialogActionKeys],
  name: "AccountEnableMFA",

  props: {
    isProcessing: {
      type: Boolean,
      default: false,
    },
  },

  data: function() {
    return {
      dialog: false,

      isSubmitted: false,
    };
  },

  mounted: function() {
    if (this.isProcessing) {
      this.dialog = false;
    }
  },

  methods: {
    async disableMFA() {
      this.isSubmitted = true;

      const authStore = useAuthStore();

      try {
        await authStore.disableTOTPMFA();
        await UserCalls.invalidateMfaCache().catch(console.error);
        this.refreshUserWithTimeout();
      } catch (error) {
        if (error && error.message) {
          this.$showMessage(error.message, { type: 'error' });
        } else {
          console.error(error); // Use console.error for errors
          this.$showMessage(this.$t('backend.system-error'), { type: 'error' });
        }
      } finally {
        // Optionally reset isSubmitted here if needed...
      }
    },
    refreshUserWithTimeout: function() {
      this.$emit('update:is-processing', true);

      let self = this;

      setTimeout(() => {
        const authStore = useAuthStore();
        authStore.refreshCognitoUser();
        self.$emit('update:is-processing', false);

        self.dialog = false;
        self.$showMessage(self.$t('menus.authentication.successfullyDisabled'));
      }, 10000);
    }
  }
};
</script>

<style>
.vb-disable-mfa-dialog .v-card__text {
  margin-top: 0.8rem;
  font-size: 1rem;
}
</style>
